import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRouteSecondaryAccounts = ({
  children,
  tokenKey = "secondaryaccountstoken",
}) => {
  const token = sessionStorage.getItem(tokenKey);
  const className = sessionStorage.getItem("className");
  const location = useLocation();

  const class9Routes = [
    "/secondary-accounts-dashboard-class-ix",
    "/secondary-accounts-fees-structure-class-ix",
    "/secondary-accounts-reject-payment-class-ix",
    "/secondary-accounts-payment-pending-class-ix",
    "/secondary-accounts-verified-payment-class-ix",
    "/secondary-accounts-challan-not-generated-class-ix",
    "/secondary-accounts-challan-pending-submission-class-ix",
    "/secondary-accounts-reports",
  ];

  const class10Routes = [
    "/secondary-accounts-dashboard-class-x",
    "/secondary-accounts-fees-structure-class-x",
    "/secondary-accounts-reject-payment-class-x",
    "/secondary-accounts-payment-pending-class-x",
    "/secondary-accounts-verified-payment-class-x",
    "/secondary-accounts-challan-not-generated-class-x",
    "/secondary-accounts-challan-pending-submission-class-x",
    "/secondary-accounts-reports",
  ];


  if (!token) {
    return <Navigate to="/secondary-accounts" />;
  }

  // Class 9 check
  if (
    className === "CLASS_9" &&
    ![...class9Routes].includes(location.pathname)
  ) {
    return <Navigate to="/secondary-accounts-dashboard-class-ix" />;
  }

  // Class 10 check
  if (
    className === "CLASS_10" &&
    ![...class10Routes].includes(location.pathname)
  ) {
    return <Navigate to="/secondary-accounts-dashboard-class-x" />;
  }

  return children;
};

export default PrivateRouteSecondaryAccounts;
